export function initializeMergeHero() {
  const rotateSpan = document.querySelector(".merge-2025-h1-rotate");
  const cells = document.querySelectorAll(".merge-2025-block-components-cell");
  const promptInput = document.querySelector('.merge-2025-block-input');
  const startBuildingBtn = document.querySelector('.merge-2025-block-link');
  const loaderContainer = document.querySelector('.merge-2025-loader');
  const loggedInContainer = document.querySelector('.merge-2025-logged-in-container');
  const mailForm = document.querySelector('.merge-2025-mail-form');
  const emailInput = document.querySelector('.form__input');
  const startEditingBtn = document.querySelector('#start_editing');
  const errorField = mailForm?.querySelector('.field-error');
  const openApp = document.querySelector('.merge-2025-logged-in-container .merge-2025-block-link');
  let prompt = '';
  let libraryType = 'shadcn';
  let isProgress = false;
  const isLoggedInPromise = fetch(`${getAppUrl()}/ajax/dmsAccounts/IsUserLoggedIn/`, { "credentials": "include" }).then((res) => res.json()).catch((e) => false);

  const examplePrompts = [
    'A fintech dashboard UI with a left sidebar for navigation and a top bar with profile and search. The main area shows total balance with key metrics, a line chart of market growth, a progress tracker for market cycles, and a trading history table. On the right side, there are recipient avatars and wallet balances. Use a modern palette with white backgrounds, light gray accents, and highlights in soft purple, blue, and gradient tones',
    'An e-commerce landing page for a furniture brand with a hero section showing bold text, a lifestyle photo, and a shop button. Below, a brand description with a call-to-action, then a featured collections grid with clean product cards — all cards must have the same size with centered images cropped to fit. Add a popular products section in a responsive grid with evenly sized boxes, a testimonial block on a pastel background, an Instagram gallery, and a dark footer with logo and links. Use a minimal palette of white, soft blue, pastel accents, and black typography.',
    'A landing page for a travel booking service with a large hero banner showing a scenic destination and a search bar for flights and hotels. Below, grid sections for featured destinations with uniform cards, customer reviews, and travel tips blog posts. Footer with contact info and social links. Palette: white backgrounds, sky blue accents, warm orange highlights.',
    'A food delivery app with a bright, friendly design. Top bar with location and search. Category icons (pizza, burgers, sushi), followed by a grid of restaurant cards with fixed image sizes. Bottom navigation for Home, Orders, Favorites, and Profile. Palette: white background with red, orange, and green accents',
    'A landing page for a wellness app. Hero section with large headline, subtle illustration, and call-to-action button. Below, three feature boxes with icons, testimonials, and a pricing plan section. Palette: pastel backgrounds in beige and mint green, with dark gray text and soft purple accents',
    'A clean web app dashboard for an online learning platform. Sidebar navigation for Courses, Progress, and Certificates. Main section with current course card, progress tracker, and grid of recommended courses with consistent card sizes. Palette: white, light gray, teal, and lime green accents',
    'A mobile music streaming app with a dark background and neon accents. Top bar shows profile and search, hero section with featured playlist cover art, and a scrollable grid of albums with equal-sized cards. Bottom navigation for Home, Search, Library, and Settings. Palette: black, deep purple, neon pink, and cyan highlights.'
  ]

  function getAppUrl() {
    const url = new URL(window.location.href);
    const hostname = url.hostname;
    if (hostname.indexOf('www.') === 0) {
      return `https://app.${hostname.replace('www.', '')}`;
    }

    return `https://app.${hostname}`;
  }

  if (rotateSpan && cells.length > 0) {
    cells.forEach((cell) => {
      cell.addEventListener("click", () => {
        cells.forEach((c) => c.classList.remove("selected"));
        cell.classList.add("selected");
        libraryType = cell.dataset.value;
      });
    });

    const words = ["MUI", "Ant Design", "Bootstrap", "Shadcn/ui", "UXPin Classic"];
    let index = 0;

    setInterval(() => {
      rotateSpan.style.opacity = 0;
      setTimeout(() => {
        index = (index + 1) % words.length;
        rotateSpan.textContent = words[index];
        rotateSpan.style.opacity = 1;
      }, 300);
    }, 2000);
  }

  promptInput.addEventListener('input', (e) => {
    prompt = e.target.value.trim();
  })

  startBuildingBtn.addEventListener('click', async (e) => {
    e.preventDefault();

    if (!prompt) {
      prompt = examplePrompts[Math.floor(Math.random() * examplePrompts.length - 1)] || examplePrompts[0];
      promptInput.value = prompt;
    }

    if (libraryType) {
      startBuildingBtn.style.display = 'none';
      const { isLoggedIn } = await isLoggedInPromise;
      if (isLoggedIn) {
        loaderContainer.style.display = 'none';
        loggedInContainer.style.display = 'block';
        return;
      }

      loaderContainer.style.display = 'flex';
      setTimeout(() => {
        loaderContainer.textContent = 'Your prototype is ready!'
        mailForm.style.display = 'block';
      }, 2000)
    }
  })

  startEditingBtn.addEventListener('click', (e) => {
    e.preventDefault();
    if (isProgress) {
      return;
    }

    errorField.textContent = '';
    startEditingBtn.textContent = 'Starting...';
    isProgress = true;
    fetch(`${getAppUrl()}/ajax/dmsAccounts/CreateAccountByMailAndPrompt/`, {
      "body": JSON.stringify({ email: emailInput.value, prompt, type: libraryType }),
      "credentials": "include",
      "method": "POST",
    }).then((res) => res.json()).then((res) => {
      if (res.error) {

        if (res.error === 'USER_EXISTS') {
          window.location.href = `${getAppUrl()}`;
          return;
        }

        if (res.error === 'SIGN_UP_FAILED') {
          errorField.textContent = 'Something went wrong!';
        }

        if (res.error === 'INVALID_EMAIL') {
          errorField.textContent = 'It`s not a valid e-mail address.';
        }

        startEditingBtn.textContent = 'Start editing';
        isProgress = false;
        return;
      }

      if (res.redirectUrl) {
        window.location.href = res.redirectUrl;
      }
      isProgress = false;
    }).catch(() => {
      isProgress = false;
    })
  })

  openApp.addEventListener('click', (e) => {
    e.preventDefault();
    window.location.href = `${getAppUrl()}/dashboard`;
  });

}
